  export class BtmPaymentMethodModel {
        billingCTN: string;
  }
